import formatter from "@/utils/formatter";

export const getAllColumns = (columns) => {
  const result = [];
  columns.forEach((column) => {
    if (column.children) {
      result.push(column);
      result.push.apply(result, getAllColumns(column.children).map(x => {
        return {
          ...x,
          parent: column.name
        }
      }));
    } else {
      result.push(column);
    }
  });
  return result;
};

export const convertToRows = (originColumns) => {
  let maxLevel = 1;
  const traverse = (column, parent) => {
    let parentId = parent ? parent._id : 0;
    column._id =
      parentId == 0 ? "" + column._index : parentId + "_" + column._index;

    if (parent) {
      column.level = parent.level + 1;
      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }
    if (column.children) {
      let colSpan = 0;
      column.children.forEach((subColumn, index) => {
        subColumn._index = index;
        traverse(subColumn, column);
        colSpan += subColumn.colSpan;
      });
      column.colSpan = colSpan;
    } else {
      column.colSpan = 1;
    }
  };

  originColumns.forEach((column, index) => {
    column.level = 1;
    column._index = index;
    traverse(column);
  });

  const rows = [];
  for (let i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  const allColumns = getAllColumns(originColumns);

  allColumns.forEach((column) => {
    if (!column.children) {
      column.rowSpan = maxLevel - column.level + 1;
    } else {
      column.rowSpan = 1;
    }
    rows[column.level - 1].push(column);
  });

  return rows;
};

export const flatColumns = (columns, holdParent = null) => {
  columns = [...columns];
  const result = [];
  columns.forEach((column) => {
    if (column.children) {
      if (holdParent) {
        result.push(column);
      }
      result.push.apply(result, flatColumns(column.children, holdParent));
    } else {
      result.push(column);
    }
  });
  return result;
};
export const summary = (columns, data, sumText, textIndex = 0) => {
  let sums = [];
  columns = flatColumns(columns);
  
  columns.forEach((column, index) => {
    if (index < textIndex) {
      return;
    }
    if (index == textIndex) {
      sums[index] = sumText;
      return;
    }

    if (column.amount === false) {
      sums[index] = "";
      return;
    }

    const precisions = [];
    const values = data.map((item) => Number(item[column.name]));
    let notNumber = true;
    values.forEach((value) => {
      if (!isNaN(value)) {
        notNumber = false;
        let decimal = ("" + value).split(".")[1];
        precisions.push(decimal ? decimal.length : 0);
      }
    });
    
    const precision = Math.max.apply(null, precisions);
    if (!notNumber) {
      sums[index] = values.reduce((prev, curr) => {
        const value = Number(curr);

        if (!isNaN(value)) {
          return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
        } else {
          return prev;
        }
      }, 0);
    } else {
      sums[index] = "";
    }

    if (column.format) {
      sums[index] = formatter.format(sums[index], column.format);
    }
  });
  return sums;
};
